export default __webpack_public_path__ + "locales/zh-CN/Translations.json?hash=f386d8e9a612c3ac215e7a93b46d66eb";